import { apply } from 'ramda'

export const minMaxYears = (years: number[]) => [apply(Math.min, years), apply(Math.max, years)]
